import { Chip, Stack } from '@mui/material';
import React, { useCallback } from 'react';
import type { FilterField } from '../../../api/models/filters.model';

interface ChipFilterFieldProps {
	field: FilterField;
	value: string[];
	onChange: (val: string[]) => void;
}

const ChipFilterField: React.FC<ChipFilterFieldProps> = ({ field, value, onChange }) => {
	// Defensive: always treat value as array
	const safeValue = Array.isArray(value) ? value : [];
	const handleChipClick = useCallback(
		(val: string) => {
			if (!onChange) return;
			if (safeValue.includes(val)) {
				onChange(safeValue.filter((v) => v !== val));
			} else {
				onChange([...safeValue, val]);
			}
		},
		[onChange, safeValue]
	);

	return (
		<div>
			<Stack direction="row" spacing={1} flexWrap="wrap" mb={1}>
				{field.values?.map((val) => {
					const stringVal = typeof val === 'string' ? val : String(val);
					return (
						<Chip
							key={stringVal}
							label={stringVal}
							color={safeValue.includes(stringVal) ? 'primary' : 'default'}
							onClick={() => handleChipClick(stringVal)}
							variant={safeValue.includes(stringVal) ? 'filled' : 'outlined'}
							style={{ marginBottom: 4 }}
						/>
					);
				})}
			</Stack>
		</div>
	);
};

export default ChipFilterField;
